(function () {
  'use strict';

  var routes = window.themeRoutes || { cartAddUrl: '/cart/add.js', cartChangeUrl: '/cart/change.js', cartUrl: '/cart.js' };
  var moneyFormat = window.themeMoneyFormat || '${{amount}}';

  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var amount = parts.join('.');
    var amountNoDecimals = parts[0];
    return moneyFormat
      .replace(/\{\{\s*amount\s*\}\}/, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, amountNoDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount);
  }

  /* ---------------- Mobile menu ---------------- */
  var menuToggle = document.getElementById('menuToggle');
  var mobileMenu = document.getElementById('mobileMenu');
  var mobileMenuClose = document.getElementById('mobileMenuClose');
  var mobileMenuScrim = document.getElementById('mobileMenuScrim');

  function openMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.add('is-open');
    mobileMenuScrim.classList.add('is-open');
    menuToggle.setAttribute('aria-expanded', 'true');
    mobileMenu.setAttribute('aria-hidden', 'false');
  }
  function closeMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('is-open');
    mobileMenuScrim.classList.remove('is-open');
    menuToggle.setAttribute('aria-expanded', 'false');
    mobileMenu.setAttribute('aria-hidden', 'true');
  }
  if (menuToggle) menuToggle.addEventListener('click', openMobileMenu);
  if (mobileMenuClose) mobileMenuClose.addEventListener('click', closeMobileMenu);
  if (mobileMenuScrim) mobileMenuScrim.addEventListener('click', closeMobileMenu);

  /* ---------------- Cart drawer ---------------- */
  var cartDrawer = document.getElementById('cartDrawer');
  var cartScrim = document.getElementById('cartScrim');
  var cartToggle = document.getElementById('cartToggle');
  var cartClose = document.getElementById('cartClose');

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartScrim.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
  }
  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartScrim.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
  }
  if (cartToggle) {
    cartToggle.addEventListener('click', function (e) {
      e.preventDefault();
      refreshCart().then(openCartDrawer);
    });
  }
  if (cartClose) cartClose.addEventListener('click', closeCartDrawer);
  if (cartScrim) cartScrim.addEventListener('click', closeCartDrawer);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeCartDrawer();
      closeMobileMenu();
    }
  });

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str == null ? '' : String(str);
    return div.innerHTML;
  }

  function renderCartDrawer(cart) {
    var itemsEl = document.querySelector('[data-cart-items]');
    var footEl = document.querySelector('[data-cart-foot]');
    var countEls = document.querySelectorAll('[data-cart-count], #cartCount');
    var subtotalEl = document.querySelector('[data-cart-subtotal]');

    countEls.forEach(function (el) { el.textContent = cart.item_count; });

    if (!itemsEl) return;

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '<p class="cart-drawer__empty" data-cart-empty>' +
        (window.themeStrings && window.themeStrings.cartEmpty || 'Your bag is empty.') + '</p>';
      if (footEl) footEl.hidden = true;
      return;
    }

    var html = cart.items.map(function (item) {
      var img = item.image ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy">' : '';
      var variantLine = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<span class="cart-drawer__item-sub">' + escapeHtml(item.variant_title) + '</span>' : '';
      return '' +
        '<div class="cart-drawer__item" data-cart-item data-key="' + item.key + '">' +
          '<div class="cart-drawer__item-thumb">' + img + '</div>' +
          '<div class="cart-drawer__item-meta">' +
            '<span class="cart-drawer__item-name">' + escapeHtml(item.product_title) + '</span>' +
            variantLine +
            '<span class="cart-drawer__item-sub">QTY ' + item.quantity + '</span>' +
            '<button type="button" class="cart-drawer__item-remove" data-cart-remove data-key="' + item.key + '">REMOVE</button>' +
          '</div>' +
          '<span class="cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</span>' +
        '</div>';
    }).join('');

    itemsEl.innerHTML = html;
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    if (footEl) footEl.hidden = false;
  }

  function refreshCart() {
    return fetch(routes.cartUrl)
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        renderCartDrawer(cart);
        return cart;
      });
  }

  document.addEventListener('click', function (e) {
    var removeBtn = e.target.closest('[data-cart-remove]');
    if (removeBtn && removeBtn.closest('.cart-drawer')) {
      e.preventDefault();
      fetch(routes.cartChangeUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: removeBtn.dataset.key, quantity: 0 })
      })
        .then(function (res) { return res.json(); })
        .then(function (cart) { renderCartDrawer(cart); });
    }
  });

  /* ---------------- Add to cart (product form) ---------------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-detail] form');
    if (!form) return;
    e.preventDefault();
    submitAddToCart(form);
  });

  function submitAddToCart(form) {
    var addBtn = form.querySelector('[data-add-to-cart]');
    if (addBtn) addBtn.disabled = true;

    var formData = new FormData(form);
    fetch(routes.cartAddUrl, {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData
    })
      .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
      .then(function (result) {
        if (!result.ok) {
          throw new Error(result.data && result.data.description || 'Unable to add to cart');
        }
        return refreshCart();
      })
      .then(function () {
        openCartDrawer();
      })
      .catch(function (err) {
        window.alert(err.message || 'That item is unavailable.');
      })
      .finally(function () {
        if (addBtn && !addBtn.hasAttribute('data-keep-disabled')) addBtn.disabled = false;
      });
  }

  /* ---------------- Variant selection (product detail) ---------------- */
  document.querySelectorAll('[data-product-detail]').forEach(function (root) {
    var variantScript = root.parentElement.querySelector('[data-product-variants]');
    var variants = [];
    try { variants = JSON.parse(variantScript.textContent); } catch (err) { variants = []; }

    var form = root.querySelector('form');
    var idInput = form.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-product-price]');
    var addBtn = form.querySelector('[data-add-to-cart]');
    var addLabel = addBtn ? addBtn.querySelector('[data-add-label]') : null;
    var optionGroups = root.querySelectorAll('[data-option-index]');
    var totalOptions = optionGroups.length;
    var selected = {};

    function findVariant() {
      return variants.find(function (v) {
        for (var i = 0; i < totalOptions; i++) {
          if (selected[i] && v.options[i] !== selected[i]) return false;
        }
        return true;
      });
    }

    function updatePillAvailability() {
      optionGroups.forEach(function (group) {
        var index = Number(group.dataset.optionIndex);
        group.querySelectorAll('.product-detail__size').forEach(function (pill) {
          var testSelection = Object.assign({}, selected);
          testSelection[index] = pill.dataset.optionValue;
          var hasMatch = variants.some(function (v) {
            for (var i = 0; i < totalOptions; i++) {
              if (testSelection[i] && v.options[i] !== testSelection[i]) return false;
            }
            return true;
          });
          var hasAvailableMatch = variants.some(function (v) {
            if (!v.available) return false;
            for (var i = 0; i < totalOptions; i++) {
              if (testSelection[i] && v.options[i] !== testSelection[i]) return false;
            }
            return true;
          });
          pill.classList.toggle('dim', !hasAvailableMatch && hasMatch);
        });
      });
    }

    optionGroups.forEach(function (group) {
      group.addEventListener('click', function (e) {
        var pill = e.target.closest('.product-detail__size');
        if (!pill) return;
        var index = Number(group.dataset.optionIndex);
        selected[index] = pill.dataset.optionValue;

        group.querySelectorAll('.product-detail__size').forEach(function (p) { p.classList.remove('active'); });
        pill.classList.add('active');

        var matched = findVariant();
        if (matched) {
          idInput.value = matched.id;
          if (priceEl) priceEl.childNodes[0].nodeValue = formatMoney(matched.price) + ' ';
        }
        updatePillAvailability();

        var allSelected = Object.keys(selected).length === totalOptions;
        if (allSelected && matched && matched.available) {
          if (addLabel) addLabel.textContent = 'ADD — ' + formatMoney(matched.price);
          if (addBtn) addBtn.disabled = false;
          submitAddToCart(form);
        } else if (allSelected && matched && !matched.available) {
          if (addLabel) addLabel.textContent = 'SOLD OUT';
          if (addBtn) addBtn.disabled = true;
        } else if (addLabel) {
          var nextGroup = Array.prototype.find.call(optionGroups, function (g) {
            return selected[Number(g.dataset.optionIndex)] === undefined;
          });
          addLabel.textContent = 'SELECT ' + (nextGroup ? nextGroup.dataset.optionName.toUpperCase() : '');
        }
      });
    });

    updatePillAvailability();

    /* Size guide popover */
    var guideToggle = root.querySelector('[data-size-guide-toggle]');
    var guideClose = root.querySelector('[data-size-guide-close]');
    var guidePanel = root.querySelector('[data-size-guide]');
    if (guideToggle && guidePanel) {
      guideToggle.addEventListener('click', function () {
        guidePanel.hidden = !guidePanel.hidden;
        if (guideClose) guideClose.style.display = guidePanel.hidden ? 'none' : '';
      });
    }
    if (guideClose && guidePanel) {
      guideClose.addEventListener('click', function () {
        guidePanel.hidden = true;
        guideClose.style.display = 'none';
      });
    }

    /* Accordion */
    var accordionToggle = root.querySelector('[data-accordion-toggle]');
    var accordionBody = root.querySelector('[data-accordion-body]');
    if (accordionToggle && accordionBody) {
      accordionToggle.addEventListener('click', function () {
        var isOpen = !accordionBody.hidden;
        accordionBody.hidden = isOpen;
        accordionToggle.setAttribute('aria-expanded', String(!isOpen));
      });
    }

    /* Gallery */
    var scrollEl = root.querySelector('[data-gallery-scroll]');
    var prevBtn = root.querySelector('[data-gallery-prev]');
    var nextBtn = root.querySelector('[data-gallery-next]');
    var dots = root.querySelectorAll('[data-gallery-dot]');
    if (scrollEl) {
      function goTo(index) {
        var slide = scrollEl.children[index];
        if (slide) scrollEl.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      }
      if (prevBtn) prevBtn.addEventListener('click', function () {
        var i = Math.round(scrollEl.scrollLeft / scrollEl.clientWidth) - 1;
        goTo(Math.max(0, i));
      });
      if (nextBtn) nextBtn.addEventListener('click', function () {
        var i = Math.round(scrollEl.scrollLeft / scrollEl.clientWidth) + 1;
        goTo(Math.min(scrollEl.children.length - 1, i));
      });
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () { goTo(Number(dot.dataset.galleryDot)); });
      });
      scrollEl.addEventListener('scroll', function () {
        var i = Math.round(scrollEl.scrollLeft / scrollEl.clientWidth);
        dots.forEach(function (dot, idx) { dot.classList.toggle('on', idx === i); });
      }, { passive: true });
    }
  });

  /* ---------------- Collection slider ---------------- */
  document.querySelectorAll('[data-collection-slider]').forEach(function (root) {
    var track = root.querySelector('[data-slider-track]');
    var prevBtn = root.querySelector('[data-slider-prev]');
    var nextBtn = root.querySelector('[data-slider-next]');
    if (!track) return;

    function step() {
      var item = track.querySelector('.collection-slider__item');
      return item ? item.getBoundingClientRect().width + 24 : track.clientWidth;
    }
    if (prevBtn) prevBtn.addEventListener('click', function () {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    if (nextBtn) nextBtn.addEventListener('click', function () {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });
  });

  /* ---------------- Cart page (fallback, non-drawer) ---------------- */
  var cartForm = document.querySelector('.cart-page__form');
  if (cartForm) {
    cartForm.addEventListener('click', function (e) {
      var minus = e.target.closest('[data-qty-minus]');
      var plus = e.target.closest('[data-qty-plus]');
      var remove = e.target.closest('[data-cart-remove]');
      if (!minus && !plus && !remove) return;
      e.preventDefault();
      var key = (minus || plus || remove).dataset.key;
      var input = cartForm.querySelector('input[data-key="' + key + '"]');
      if (!input) return;
      if (minus) input.value = Math.max(0, Number(input.value) - 1);
      if (plus) input.value = Number(input.value) + 1;
      if (remove) input.value = 0;

      var updates = {};
      cartForm.querySelectorAll('[data-qty-input]').forEach(function (el) {
        updates[el.dataset.key] = Number(el.value);
      });

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(function () { window.location.reload(); });
    });
  }
})();
